// extracted by mini-css-extract-plugin
module.exports = {"rating":"Eh-z","numberOfStars":"Fh-z","count":"Gh-z"};